import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../services/auth';
import { superAdminAPI } from '../services/api';

/**
 * Protected route component for super-admin pages.
 * Checks if user has super-admin access (global DEVELOPER role) by attempting an API call.
 * Backend will reject if user doesn't have DEVELOPER role.
 */
function ProtectedSuperAdminRoute({ children }) {
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const checkAccess = async () => {
      if (!isAuthenticated()) {
        setChecking(false);
        return;
      }

      try {
        // Try to access super-admin endpoint - backend will reject if not authorized
        await superAdminAPI.getAllOrgs();
        setHasAccess(true);
      } catch (error) {
        // 403 = no access, 401 = not authenticated
        setHasAccess(false);
      } finally {
        setChecking(false);
      }
    };

    checkAccess();
  }, []);

  if (checking) {
    return <div className="loading" style={{ padding: '40px', textAlign: 'center' }}>Checking access...</div>;
  }

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (!hasAccess) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <h2>Access Denied</h2>
        <p>Super-admin access requires the global DEVELOPER role.</p>
        <p>This page is only accessible to system administrators.</p>
      </div>
    );
  }

  return children;
}

export default ProtectedSuperAdminRoute;
